import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { settingsAPI } from '../utils/api';
import LOCATIONS from '../data/locations';
import { GOOGLE_REVIEW_URL } from '../utils/brand';

function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await settingsAPI.get();
      setSettings(response.data);
    } catch (error) {
      // Settings endpoint doesn't exist yet - use defaults
      console.log('Using default settings');
      setSettings(null);
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div>
            <h3>{settings?.siteName || 'Utah Realty Photos'}</h3>
            <p>{settings?.aboutText || 'Professional real estate photography services in Utah.'}</p>
          </div>
          
          <div>
            <h3>Quick Links</h3>
            <Link to="/portfolio">Portfolio</Link>
            <Link to="/services">Services</Link>
            <Link to="/book">Book a Session</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/credit">Credit</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/about">About</Link>
          </div>
          
          <div>
            <h3>Areas We Serve</h3>
            {LOCATIONS.map((loc) => (
              <Link key={loc.slug} to={`/locations/${loc.slug}`}>{loc.name}</Link>
            ))}
            <Link to="/locations" style={{ fontWeight: 600 }}>All Service Areas</Link>
          </div>
          
          <div>
            <h3>Login</h3>
            <Link to="/client/login">Client Portal</Link>
            <Link to="/photographer/login">Photographer Portal</Link>
            <Link to="/admin/login">Admin Dashboard</Link>
          </div>
          
          <div>
            <h3>Contact</h3>
            <p>Email: {settings?.contactEmail || 'info@utahrealtyphotos.com'}</p>
            {settings?.contactPhone && <p>Phone: {settings.contactPhone}</p>}
            <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer">Leave a Google Review</a>
          </div>
          
          {settings?.socialMedia && (
            <div>
              <h3>Follow Us</h3>
              {settings.socialMedia.instagram && (
                <a href={settings.socialMedia.instagram} target="_blank" rel="noopener noreferrer">
                  Instagram
                </a>
              )}
              {settings.socialMedia.facebook && (
                <a href={settings.socialMedia.facebook} target="_blank" rel="noopener noreferrer">
                  Facebook
                </a>
              )}
            </div>
          )}
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Utah Realty Photos. All rights reserved.</p>
          <p><Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/cookie-policy">Cookie Policy</Link></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
